import CaicCommonPicker from './src/CaicCommonPicker.vue'
const CommonPicker = {
  install: function(Vue) {
    Vue.component(CaicCommonPicker.name, CaicCommonPicker)
  }
}
export default CommonPicker



// WEBPACK FOOTER //
// ./src/common-picker/index.js